export function swInteger(sharedModule) {
  /**
   * Directive that rounds the input value to the closes integer. Can be used
   * either with `<input sw-number />` or `<input type="number" />`.
   */
  sharedModule.directive('swInteger', () => ({
    restrict: 'A',
    require: '?ngModel',
    priority: 10,

    link: function postLink(scope, element, attrs, ctrl) {
      ctrl.$formatters.push((modelValue) => {
        if (!angular.isNumber(modelValue)) {
          return;
        }

        return Math.round(modelValue);
      });

      ctrl.$parsers.push((viewValue) => {
        if (!angular.isNumber(viewValue)) {
          return;
        }

        return Math.round(viewValue);
      });

      // normally swNumber cleans up value on blur; but if it's not there, we
      // set the event here
      if (angular.isUndefined(attrs.swNumber)) {
        element.on('blur', () => {
          ctrl.$setViewValue(Math.round(ctrl.$modelValue).toString());
          ctrl.$render();
        });
      }
    },
  }));
}
